export default {
  apiNotAvailable: 'NPM API unavailable',
  systemKnown: 'System known to NPM API',
  systemUnknown: 'System unknown to NPM API',
};
